import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";

import Fab from "@material-ui/core/Fab";
import Card from "@material-ui/core/Card/Card";
import {createMuiTheme} from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import RefreshIcon from "@material-ui/icons/Refresh";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import CheckIcon from "@material-ui/icons/Check";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";

import { CustomizedSnackbars, ApolloMessage } from "../../../atom/Apollo_Mesasge";
import { APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, ApolloPageUsagePermission } from "../../../atom/Apollo_Authorization";
import { ApolloContext } from "../../../atom/Apollo_Context";
import { 
  apollo_useStyles, 
  valueToOption, 
  options_status, 
  options_input_type,
  options_affinity_usage,
} from "../../../atom/Apollo_styles";
import { 
  apollo_users_path,
  affinitycategoryeditposeidon_path,
  list_poseidon_affinitycategory_path,
  get_poseidon_condition_path,
} from "../../../atom/Apollo_links";
import GenericTemplate from "../../../templates/GenericTemplate";
import { 
  Status,
  GetSegmentCondition,
  POSEIDON_CONDITION,
  POSEIDON_CONDITION_UPDATEDAT,
} from "./SegmentModel";
import { ResListAffinityCategories } from "./AffinityCategoryModel";
import { ApolloAxios } from "../../../atom/Apollo_ApiRequest3";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import { ApolloDataTable, STORAGE_KEY } from "../../../atom/Apollo_DataTable";

import moment from "moment";
import "moment/locale/ja";
import { MUISortOptions, SelectableRows } from "mui-datatables";

import {Bars} from "react-loader-spinner";
import {Backdrop, Button} from "@material-ui/core";

/*
    画面名：アフィニティカテゴリ一覧
 */
const AffinityCategoryTop: React.FC = () => {
  const history = useHistory();
  const { state } = React.useContext(ApolloContext);
  const { data, setmsg } = React.useContext(ApolloMessage);

  const [affinityCategories, setAffinityCategories] = useState<ResListAffinityCategories[]>([]);
  const [progress, setProgress] = useState(false);

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 8,
    breadId: 6,
    queries: [],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  React.useEffect(() => {
    const init = async () => {
      setProgress(true);

      // セグメント条件取得
      let lsCondition = localStorage.getItem(POSEIDON_CONDITION);
      let lsConditionUpdatedAt = localStorage.getItem(POSEIDON_CONDITION_UPDATEDAT);

      let updatedAt1: string = "";
      if (lsCondition != null && lsConditionUpdatedAt != null) {
        updatedAt1 = lsConditionUpdatedAt;
      }

      var request: GetSegmentCondition = {
        updatedAt: updatedAt1,
      };

      const url = get_poseidon_condition_path;
      await ApolloAxios.post(url, request).then(response => {
        if (response.data.resultCode < 0) {
          return;
        }

        let result1 = response.data.result;
        localStorage.setItem(POSEIDON_CONDITION, "["+result1.condition+"]");
        localStorage.setItem(POSEIDON_CONDITION_UPDATEDAT, result1.updatedAt);
      }).catch(err => {
        console.log(err)
      });

      // アフィニティカテゴリ一覧取得
      await getAffinityCategoryList();

      setProgress(false);
    }
    init();
  }, []);

  /** アフィニティカテゴリ一覧取得 */
  const getAffinityCategoryList = async () => {
    setProgress(true);

    let result1: any = null;

    // ユーザリスト取得
    const url1: string = apollo_users_path;
    await ApolloAxios.get(url1).then(response => {
      result1 = response.data.result;
    }).catch(err => {
      const errMsg = `ユーザ情報の取得に失敗しました。`
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errMsg,
        }
      });

      setProgress(true);
      return;
    });

    // アフィニティカテゴリ一覧取得
    const url2: string = list_poseidon_affinitycategory_path;
    await ApolloAxios.get(url2).then(response => {
      let resultCode: number = response.data.resultCode;
      if (resultCode < 0 || resultCode === 2) {
        setProgress(false);
        let type1: string = "error";
        if (resultCode === 2) {
          type1 = "info"
        }

        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: type1,
            message: response.data.message,
          }
        });
        return;
      }

      let affinityCategories1: ResListAffinityCategories[] = [];

      response.data.result.map((data: any) => {
        let uuData: number = data.uu;
        if (data.uu === undefined) {
          uuData = 0;
        }

        let updatedBy: string = "";
        result1.map((res1: any) => {
          if (data.updatedBy === res1.userId) {
            updatedBy = res1.familyName+" "+res1.firstName;
          }
        });

        let affinityCategory1: ResListAffinityCategories = {
          id: data.id,
          name: data.name,
          status: data.status,
          uu: uuData,
          inputType: valueToOption(data.inputType, options_input_type).label,
          usage: valueToOption(data.usage, options_affinity_usage).label,
          updatedAt: data.updatedAt,
          updatedBy: updatedBy,
        };
        affinityCategories1.push(affinityCategory1);
      });

      setAffinityCategories(affinityCategories1);
    }).catch(err => {
      const errMsg = `アフィニティカテゴリ情報の取得に失敗しました。`
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errMsg,
        }
      });
    });

    setProgress(false);
  }

  const classes = apollo_useStyles();
  const theme = createMuiTheme({});
  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "status",
      label: "ステータス",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return value ? (
            <Tooltip title={valueToOption(value, options_status).label}>
              <span>
                {value === Status.Available ? (
                  <img
                    src={"/img/poseidon/success.png"}
                    alt="利用可"
                    height="32"
                    width="auto"
                  />
                ) : value === Status.Processing ? (
                  <img
                    src={"/img/poseidon/loading.gif"}
                    alt="処理中"
                    height="32"
                    width="auto"
                  />
                ) : value === Status.Invalid ? (
                  <img
                    src={"/img/poseidon/invalid.png"}
                    alt="無効"
                    height="32"
                    width="auto"
                  />
                ) : value === Status.Validating ? (
                  <img
                    src={"/img/poseidon/validating.png"}
                    alt="検証中"
                    height="32"
                    width="auto"
                  />
                ) : (
                  <img
                    src={"/img/poseidon/error.png"}
                    alt="利用不可"
                    height="32"
                    width="auto"
                  />
                )}
              </span>
            </Tooltip>
          ) : (
            <div></div>
          );
        },
      },
    },
    {
      name: "name",
      label: "アフィニティカテゴリ名",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: any) => {
          return (
            <Tooltip title={value}>
              <span>{value}</span>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "uu",
      label: "UU",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: number) => {
          return value.toLocaleString();
        },
      },
    },
    {
      name: "inputType",
      label: "タイプ",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return value ? (
            <Tooltip title={value}>
              <span>
                {value === "条件指定" ? (
                  <CheckIcon />
                ) : (
                  <InsertDriveFileIcon />
                )}
              </span>
            </Tooltip>
          ) : (
            <div></div>
          );
        },
      },
    },
    {
      name: "usage",
      label: "公開設定",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return (
            <div>{value}</div>
          )
        },
      },
    },
    {
      name: "updatedBy",
      label: "最終更新ユーザ",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return (
            <p>{value}</p>
          );
        },
      },
    },
    {
      name: "updatedAt",
      label: "最終更新",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: string) => {
          return (
            <Tooltip
              title={moment(value).format("YYYY/MM/DD HH:mm:ss")}
            >
              <span>{moment(value).fromNow()}</span>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: number, tableMeta: any) => {
          let affinityCategoryId: number = tableMeta.rowData[0];
          let status: string = "";

          affinityCategories.map((affinityCategory: any) => {
            if (affinityCategory.id === affinityCategoryId) {
              status = affinityCategory.status;
            }
          });

          return (
            <Tooltip title="アフィニティカテゴリ編集" placement="top">
              <KeyboardArrowRightIcon
                onClick={() =>
                  history.push(`${affinitycategoryeditposeidon_path}${affinityCategoryId}`)
                }
                className={classes.link}
                style={{ cursor: "pointer" }}
              />
            </Tooltip>
          );
        },
      },
    },
  ];

  const sortOrder: MUISortOptions = {
    name: "id",
    direction: "asc",
  };
  const selectableRows: SelectableRows = "none";
  const options = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.AFFINITY_CATEGORY) ? undefined : sortOrder,
    selectableRows: selectableRows,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.AFFINITY_CATEGORY,
    textLabels:{
      body: {noMatch: "該当データが存在しません"}
    },
  };

  return (
    <div>
      <GenericTemplate title={""}>
        <Backdrop className={classes.backdrop2} open={progress}>
          <Bars color="#00BFFF" height={80} width={80} />
        </Backdrop>
        <CustomizedSnackbars />
        <ApolloPageUsagePermission role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
          <ApolloBreadcrumbs2 data={breadcrumbsData}/>

          <Tooltip title="アフィニティカテゴリ新規作成" placement="bottom">
            <Link to={`${affinitycategoryeditposeidon_path}0`} className={classes.link}>
              <Fab size="small" color="primary" aria-label="add" style={{marginTop: "10px"}}>
                <AddIcon />
              </Fab>
            </Link>
          </Tooltip>

          <Tooltip title="アフィニティカテゴリ一覧更新" placement="bottom">
            <Button onClick={getAffinityCategoryList}>
              <Fab size="small" color="primary" aria-label="update" style={{marginTop: "10px", marginLeft: "10px"}}>
                <RefreshIcon />
              </Fab>
            </Button>
          </Tooltip>

          <Card className={classes.root} square variant="outlined">
            <ApolloDataTable
              title=""
              data={affinityCategories ? affinityCategories : []}
              columns={columns}
              options={options}
            />
          </Card>
        </ApolloPageUsagePermission>
      </GenericTemplate>
    </div>
  );
};

export default AffinityCategoryTop;
